import request from '@/utils/request';

// 获取待发货/已发货列表
export function getLbmulAllNewOrdersApi(data) {
  return request({
    url: '/ecom/multi/getAllNewOrders',
    method: 'post',
    data
  });
}
// 获取全部订单列表
export function getLbmulAllOrdersApi(data) {
  return request({
    url: '/ecom/multi/getAllOrders',
    method: 'post',
    data
  });
}
// 获取订单列表的统计数据
export function getLbmulOrdersCountApi(data) {
  return request({
    url: '/ecom/multi/getAllNewOrdersCount',
    method: 'post',
    data
  })
}
// 订单锁定
export function lockOrderLbmulApi(data) {
  return request({
    url: '/ecom/multi/lockOrder',
    method: 'post',
    data
  });
}
// 修改买家留言
export function updateLbmulBuyerInfoApi(data) {
  return request({
    url: '/ecom/multi/updateBuyerInfo',
    method: 'post',
    data
  });
}
// 全部拆单接口
export function splitLbmulOrderAllApi(data) {
  return request({
    url: '/ecom/multi/splitOrderAll',
    method: 'post',
    data
  });
}
// 单个拆单接口
export function splitLbmulOrderApi(data) {
  return request({
    url: '/ecom/multi/splitOrder',
    method: 'post',
    data
  });
}
// 当前账号下所有未打印订单拆分
export function splitLbmulUserAllOrderApi(data) {
  return request({
    url: '/ecom/multi/splitUserAllOrder',
    method: 'post',
    data
  });
}
// 保存管家备注接口
export function updateLbmulKhgjRemarkApi(data) {
  return request({
    url: '/ecom/multi/updateKhgjRemark',
    method: 'post',
    data
  });
}
// 修改卖家留言
export function updateLbmulReceiveWordsApi(data) {
  return request({
    url: '/ecom/multi/updateReceiveWords',
    method: 'post',
    data
  });
}
// 收件人信息解密（抖音平台除外，后端按 platformCode 分发各平台解密）
export function lbmulDecryptReceiveMessageApi(data) {
  return request({
    url: '/ecom/multi/decryptReceiveMessage',
    method: 'post',
    data
  });
}
// 获取商品&规格信息
export function lbmulGetAllProductApi(data) {
  return request({
    url: '/ecom/multi/getAllOrderNewProduct',
    method: 'post',
    data
  })
}
// 打印历史记录接口--抖音多店铺
export function getLbmulPrintHistApi(data) {
  return request({
    url: '/ecom/multi/getOrderPrintHist',
    method: 'post',
    data
  });
}
// 自动合单配置查询
export function queryLbmultiConfigApi(data) {
  return request({
    url: '/ecom/autoMergeConfig/queryMultiConfig',
    method: 'post',
    data
  });
}
// 保存自动合单配置
export function addLbmultiConfigApi(data) {
  return request({
    url: '/ecom/autoMergeConfig/addMultiConfig',
    method: 'post',
    data
  });
}
// 全部待合订单合并接口
export function mergeLbmulOrderAllApi(data) {
  return request({
    url: '/ecom/multi/mergeOrderAll',
    method: 'post',
    data
  });
}
// 获取高级查询条件列表
export function getMulitAdvanceQueryApi(data) {
  return request({
    url: '/ecom/multi/getMulitAdvanceQueryAll',
    method: 'post',
    data
  });
}
// 保存高级查询条件
export function insertMulitAdvanceQueryApi(data) {
  return request({
    url: '/ecom/multi/insertMulitAdvanceQuery',
    method: 'post',
    data
  });
}
// 选择订单-拆单接口
export function splitLbmulBatchOrderApi(data) {
  return request({
    url: '/ecom/multi/splitBatchOrder',
    method: 'post',
    data
  });
}

// 设置商品简称
export function updateLbmulProductShortNameApi(data) {
  return request({
    url: '/ecom/multi/updateProductShortName',
    method: 'post',
    data
  });
}
// 订单导出
export function lbmulExportOrdersInfoApi(data) {
  return request({
    url: '/ecom/multi/exportOrdersInfoNew',
    method: 'post',
    data,
    responseType: 'blob'
  });
}
// 抖音官方模板新拉单
export function lbmulApplyWaybillCodeApi(data) {
  return request({
    url: '/ecom/applyWaybillCode',
    method: 'post',
    timeout: 100000,
    data
  });
}
// 获取打印机报文的接口
export function lbmulApplyPrinterDataApi(data) {
  return request({
    headers: {
      source: 'YTO-STEWARD',
      'REST-CLIENT': 'REST-CLIENT',
      'jwt-token': '',
      'khgj-chanel': 'PC',
       'Accept': 'text/plain; chunks=true'
    },
    url: '/ecom/applyPrinterData',
    method: 'post',
    responseType: 'stream', // 设置相应类型为流
    timeout: 100000,
    data
  });
}
// 获取打印历史单号--抖音
export function getLbmulOrderOldWaybillNoListApi(data) {
  return request({
    url: '/ecom/multi/getOrderOldWaybillNoList',
    method: 'post',
    data
  });
}
// 待合列表接口
export function getLbmulPreMergeListApi(data) {
  return request({
    url: '/ecom/multi/getPreMergeList',
    method: 'post',
    data
  });
}
// 订单合并接口
export function mergeLbmulOrderApi(data) {
  return request({
    url: '/ecom/multi/mergeOrder',
    method: 'post',
    data
  });
}
// 首次发货
export function lbmulFirstDeliverApi(data) {
  return request({
    url: '/ecom/multi/firstDeliver',
    method: 'post',
    data
  });
}
// 重新发货
export function lbmulUpdateDeliverApi(data) {
  return request({
    url: '/ecom/multi/updateDeliver',
    method: 'post',
    data
  });
}
// 打印发货单状态刷新
export function updateLbmulDeliverPrintedStatusApi(data) {
  return request({
    url: '/ecom/multi/updateDeliverStatus',
    method: 'post',
    data
  });
}
// 获取高级配置/打印项记录 多店铺场景（跟账号走）
export function queryUserMallConfigApi(data) {
  return request({
    url: '/ecom/common/queryUserMallConfig',
    method: 'post',
    data
  });
}
// 更新高级配置/打印项记录 多店铺场景（跟账号走）
export function updateUserMallConfigApi(data) {
  return request({
    url: '/ecom/common/updateUserMallConfig',
    method: 'post',
    data
  });
}
// 更新圆通优选时效的接口
export function ytoLbmulPerferTimeFlagSynApi(data) {
  return request({
    url: '/ecom/multi/ytoPerferTimeFlagSyn',
    method: 'post',
    data
  });
}
// 删除高级查询条件
export function deleteMulitAdvanceQueryApi(id) {
  return request({
    url: '/ecom/multi/deleteMulitAdvanceQuery/'+id,
    method: 'post',
    data: {}
  });
}
